<template>
  <main class="mt-3">
    <div v-if="isLoading" class="loading-indicator">
      <span class="spinner"></span>
      <span class="text-success">데이타 로딩 중...</span>
    </div>    

    <div class="pl-1 text-center">
      <div class="mb-1 row">
        <div class="container-fluid">
          <h2 class="text-center fw-bold">
            <u>&nbsp;App Push 관리&nbsp;</u>
          </h2>

          <div class="top-container d-flex align-items-center justify-content-between">
            <div class="flex-item">
              <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_procCode" v-model="puPeriod" @change="changePeriod()">
                <option :value="noval" disabled>2026년 12월 4월까지</option>
                <option value="2026-04-31">2026년 04월 까지</option>
                <option value="2026-08-31">2026년 08월 까지</option>
                <option value="2026-12-31">2026년 12월 까지</option>
                <option value="2025-12-31">2025년 12월 이전</option>
              </select>
            </div>
            <div class="float-end mb-1">
              <button type="button" class="btn btn-primary" @click="goToInsert">PUSH전송하기</button>
            </div>
          </div>

          <div>
            <table class="table table-bordered table-striped border-success align-middle w-100 h-auto">
              <tr class="tb_pushMan bg-info">
                <th style="width: 5%;" >번호</th>
                <th style="width: 7%;">푸시코드</th>
                <th style="width: 15%;" >푸시대상</th>
                <th style="width: 15%;">제목</th>
                <th style="width: 20%;">내용</th>
                <th style="width: 15%;">앱링크</th>
                <th style="width: 7%;">발송일</th>
                <th style="width: 5%;" >상태</th>
                <th style="width: 7%;" >확인일</th>
              </tr>
              <tr :key="i" v-for="(p, i) in this.puList" style="font-size: 0.9rem;">
                <td>{{i++}}</td>

                <td style="font-size: 0.8rem; color:darkgray;" v-if="!p.puCode">자동발송</td>
                <td style="font-size: 0.8rem; color:darkgray;" v-else>{{p.puCode}}</td>

                <td style="text-align: left; padding-left: 2px; color:blue;">
                  {{p.puUserId}}&nbsp;<span style="color: black;">({{ p.uNickName }})</span>
                </td>
                <td>{{p.puTitle}}</td>
                <td>{{p.puContent}}</td>
                <td>{{p.puLink}}</td>

                <td v-if="!p.puDate"></td>
                <td v-else>{{this.getDateFormat(p.puDate)}}</td>

                <td v-if="p.puResponse === 'ok'">성공</td>
                <td v-else-if="!p.puResponse || p.puResponse === 'err'" style="color: red;">실패</td>
                
                <td v-if="!p.checkDate"></td>
                <td v-else>{{this.getDateFormat(p.checkDate)}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import moment from 'moment';

export default {
  // components: {
  //   DatePicker
  // },
  data() {
    return {
      isLoading: false,         // 로딩중 여부

      puList: [],               //푸시발송리스트
      puPeriod: '2025-12-31',   //푸시발송기간
    };
  },
    // 로그인된 사용자만 접근가능페이지
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  // 생성 시, 상품카테고리 가져온다
  created() {
    this.getPushManList()         //푸시발송리스트
  },
  mounted() {
    // 로그인한 사람이 아니라면 메인화면으로
    if(this.user.handlerGrade > 9 || this.user.handlerGrade == undefined) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '',
        text: '로그인 권한이 없습니다.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }

    ////document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";

    const today_tmp = moment();
    let today1 = moment([today_tmp.year(), today_tmp.month(), today_tmp.date()]);
    this.today = today1.format("YYYY-MM-DD")
  },
  methods: {
    //로딩인디케이터
    showLoading() {
      this.$loading.start()
      setTimeout(() => {
        this.$loading.finish()
      }, 3000)
    },

    // mixins에 있는 공통함수 호출샘플
    /** 자릿수 표시 */
    getCurrencyFormat(value) {
      //return this.$currencyFormat(value);
      if(isNaN(value)) 
      { 
        location.reload()
      }
      else
      {
        return this.$currencyFormat(value);
      }      
    },

    /** 개행처리 */
    getStringFormat(text) {
      return this.$stringFormat(text);
    },

    getDateFormat(date)
    {
      return this.$dateFormat(date);
    },

    async getPushManList(startDate, endDate) {
      //로딩표시 시작
      this.isLoading = true;
      this.$loading.start();

      let puList = []

      if(startDate == "" || startDate == undefined) 
      {
        startDate = '2026-01-01'
      }

      if(endDate == "" || endDate == undefined)
      {
        endDate = '2026-04-31'
      }      

      puList = await this.$api("/api/list_pushHistory_manPerPeriod", { param: [startDate, endDate]});
      
      if(puList.length > 0)
      {
        this.puList = puList
      }
      else 
      {
        this.puList = []
        this.$swal.fire("", "발송내역이 없습니다", "info")
      }

      this.isLoading = false;
      this.$loading.finish();       //인디케이터 중지      
    },

    async changePeriod() {
      this.isLoading = true;
      this.$loading.start();

      if(this.puPeriod === '2025-12-31') 
      {
        this.getPushManList('2025-01-01', this.puPeriod);
      }
      else if(this.puPeriod === '2026-04-31') 
      {
        this.getPushManList('2026-01-01', this.puPeriod);
      }
      else if(this.puPeriod === '2026-08-31') 
      {
        this.getPushManList('2026-05-01', this.puPeriod);
      }
      else if(this.puPeriod === '2026-12-31') 
      {
        this.getPushManList('2026-09-01', this.puPeriod);
      }

      this.isLoading = false;
      this.$loading.finish();       //인디케이터 중지
    },

    //푸시전송페이지로 이동
    goToInsert() {
      this.$router.push({path: '/ma_PushSend'});
    },    
  }
}
</script>

<style scoped>
.tb_pushMan td {
  text-align: center;
  vertical-align: middle;
}

/* 제목과 내용 컬럼만 넘침 방지 */
.tb_pushMan td:nth-child(4),
.tb_pushMan td:nth-child(5) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 0;
}

/* 호버 시 전체 내용 보기 (선택사항) */
.tb_pushMan td:nth-child(4):hover,
.tb_pushMan td:nth-child(5):hover {
  overflow: visible;
  white-space: normal;
  position: relative;
  z-index: 1;
}

  /**************************************
    # 로딩 인디케이터
  **************************************/
  .loading-indicator {
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  background: rgba(255,255,255,0.95);
  border-radius: 10px;
  padding: 2rem 2.5rem;
  box-shadow: 0 2px 16px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  font-size: 1.3rem;
  font-weight: bold;
  color: #007bff;
}
.spinner {
  width: 28px;
  height: 28px;
  border: 4px solid #e0e0e0;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  margin-right: 1rem;
  animation: spin 1s linear infinite;
}
</style>